import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import connect from 'react-redux/es/connect/connect';
import withReactContent from 'sweetalert2-react-content';
import swal from 'sweetalert2';

import './EventThemes.sass';
import {
  deleteEventTheme,
  getEventTheme,
  updateEventTheme,
} from '../../../../../store/actions/eventsActions';
import { getDefaultStyles } from '../../../../../helpers/getDefaultStyles';
import { ThemeSettings } from '../../../../../components/Themes/ThemeColorSettings/ThemeSettings';
import NewLoader from '../../../../../components/NewLoader/NewLoader';
import CheckBox from '../../../../../components/UI/Checkbox/CheckBox';

const MySwal = withReactContent(swal);

export const EventThemes = ({
  getEventTheme,
  updateEventTheme,
  currentEvent,
  loading,
  deleteEventTheme,
}) => {
  const {
    fontFamily,
    primaryColor,
    primarySemiLightColor,
    primaryLightColor,
    secondaryColor,
    secondaryLightColor,
    backgroundColor,
    textColor,
    secondaryTextColor,
  } = getDefaultStyles(document.getElementById('body'));

  const defaultTheme = {
    fontFamily,
    primaryColor,
    primarySemiLightColor,
    primaryLightColor,
    secondaryColor,
    secondaryLightColor,
    backgroundColor,
    primaryTextColor: textColor,
    secondaryTextColor,
  };

  const [theme, setTheme] = useState(defaultTheme);
  const [isThemeEdited, setThemeEdited] = useState(false);
  const [isPromoterThemeByDefault, setPromoterThemeByDefault] = useState(false);

  const getData = async () => {
    const data = await getEventTheme(currentEvent.id);

    if (data) {
      setTheme(data);
    } else {
      setTheme(defaultTheme);
      setPromoterThemeByDefault(true);
    }
  };

  const handleChangeSetting = (name, value) => {
    setThemeEdited(true);
    setTheme((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleChangeDefaulteTheme = () => {
    setThemeEdited(true);
    setPromoterThemeByDefault((prev) => !prev);
  };

  const saveTheme = () => {
    MySwal.fire({
      title: 'Do you want to save changes?',
      customClass: 'swal2-modal',
      showCancelButton: true,
      confirmButtonText: 'Save',
      reverseButtons: true,
    }).then((result) => {
      if (result.value) {
        if (isPromoterThemeByDefault) {
          deleteEventTheme(currentEvent.id).then(() => getData());
        } else {
          updateEventTheme(currentEvent.id, theme);
        }

        setThemeEdited(false);
      }
    });
  };

  useEffect(() => {
    if (currentEvent.id) {
      getData();
    }
  }, [currentEvent]);

  if (loading) {
    return <NewLoader />;
  }

  return (
    <section className='event-themes'>
      <CheckBox
        checked={isPromoterThemeByDefault}
        id='isPromoterThemeByDefault'
        name='isPromoterThemeByDefault'
        onChange={handleChangeDefaulteTheme}
      >
        <span className='input-behavior'>Set promoter theme by default</span>
      </CheckBox>

      <div className='event-themes__settings-wrapper'>
        <ThemeSettings
          theme={theme}
          handleChangeSetting={handleChangeSetting}
        />
        {isPromoterThemeByDefault && (
          <div className='event-themes__settings-disabler'></div>
        )}
      </div>

      <div className='event-themes__buttons-container'>
        <button
          type='button'
          className='btn-primary'
          onClick={saveTheme}
          disabled={!isThemeEdited}
        >
          Save
        </button>
      </div>
    </section>
  );
};

const mapStateToProps = ({ events }) => ({
  loading: events.loading,
  theme: events.theme,
  currentEvent: events.currentEvent,
});

const mapDispatchToProps = (dispatch) => ({
  getEventTheme: (eventId) => dispatch(getEventTheme(eventId)),
  updateEventTheme: (eventId, data) =>
    dispatch(updateEventTheme(eventId, data)),
  deleteEventTheme: (eventId) => dispatch(deleteEventTheme(eventId)),
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(EventThemes)
);
